export default __webpack_public_path__ + "static/media/AXM-PK-29304.56c547ac.jpg";